/* ============================================================================
   Cart drawer - JavaScript extrait de sections/xm-cart-drawer.liquid le 15/09/2026.
   Ces blocs etaient servis en <script> INLINE sur chaque page du site, donc jamais
   mis en cache et re-analyses a chaque navigation. Ils sont ici dans l'ordre
   d'origine, charges en `defer`.

   Les valeurs venant de l'admin sont lues :
     - tailles de la croix  -> custom properties --xm-close-size-*
     - carte personnalisee  -> window.XM_CART_NOTE_CFG (pose inline par la section)

   Le bloc VARIANT est la version corrigee : il AJOUTE avant de retirer, reporte les
   proprietes de ligne, verifie chaque reponse, et retire l'ancienne variante sur un
   panier relu (une remise automatique peut re-cler les lignes entre deux appels).
   ============================================================================ */
/* ===== SHADOW ===== */
    /* Inject styles INSIDE the cart-drawer's shadow root to guarantee they apply on every
       browser. External ::part() rules with !important sometimes lose to the theme's own
       shadow-scoped rules — internal ones never do. Also lets us reach inside elements
       like the close-button's <svg> that aren't exposed as a part.
       Runs always (even when cart is empty) so the close-icon size is consistent. */
    (function () {
      if (window.__xmCartDrawerShadowStyle) return;
      window.__xmCartDrawerShadowStyle = true;
      /* Tailles lues dans les custom properties posees par la section (cf. :root inline). */
      function cssPx(name, fallback) {
        var v = getComputedStyle(document.documentElement).getPropertyValue(name);
        var n = parseFloat(v);
        return isNaN(n) ? fallback : n;
      }
      var CLOSE_DESKTOP = cssPx('--xm-close-size-desktop', 14);
      var CLOSE_MOBILE = cssPx('--xm-close-size-mobile', 14);
      function inject() {
        var d = document.getElementById('cart-drawer');
        if (!d || !d.shadowRoot) return false;
        if (d.shadowRoot.getElementById('xm-cart-drawer-shadow-overrides')) return true;
        var s = document.createElement('style');
        s.id = 'xm-cart-drawer-shadow-overrides';
        /* Header compact (titre YOUR CART) : padding-block réduit par défaut. */
        var headerCompactCss =
          '[part="header"] {' +
          '  padding-block: .5rem !important;' +
          '  min-height: 0 !important;' +
          '}' +
          /* Croix close TOUJOURS à droite — même en cart vide où le slot=header est vide
             (sans cette règle, le close button peut se retrouver à gauche faute d\'élément à droite). */
          '[part~="close-button"] {' +
          '  margin-inline-start: auto !important;' +
          '}';
        /* Fond + hauteur du header peints quand un bandeau Free gifts est présent.
           Les CSS variables (--gifts-banner-bg, --gifts-banner-padding-block) sont définies
           sur <cart-drawer> côté light DOM — les custom properties traversent les shadow boundaries.
           IMPORTANT : on neutralise le fond jaune si le cart est vide (.drawer--center-body), même si
           le block free_gifts est défini côté admin — pas de banner sans items. */
        var giftsBannerCss =
          ':host(.cart-drawer--has-gifts-banner):not(.drawer--center-body) [part="header"] {' +
          '  background: var(--gifts-banner-bg, #fff6e8) !important;' +
          '  padding-block: var(--gifts-banner-padding-block, 12px) !important;' +
          '  border-bottom: 0 !important;' +
          '}' +
          ':host(.drawer--center-body) [part="header"] {' +
          '  background: transparent !important;' +
          '}';
        var closeCss =
          '[part~="close-button"] {' +
          '  width: auto !important;' +
          '  height: auto !important;' +
          '  padding: 8px !important;' +
          '}' +
          '[part~="close-button"] svg,' +
          '[part~="close-button"] > svg,' +
          'button[part~="close-button"] svg {' +
          '  width: ' + CLOSE_DESKTOP + 'px !important;' +
          '  height: ' + CLOSE_DESKTOP + 'px !important;' +
          '  min-width: ' + CLOSE_DESKTOP + 'px !important;' +
          '  min-height: ' + CLOSE_DESKTOP + 'px !important;' +
          '}' +
          '@media screen and (max-width: 999px) {' +
          '  [part~="close-button"] svg,' +
          '  [part~="close-button"] > svg,' +
          '  button[part~="close-button"] svg {' +
          '    width: ' + CLOSE_MOBILE + 'px !important;' +
          '    height: ' + CLOSE_MOBILE + 'px !important;' +
          '    min-width: ' + CLOSE_MOBILE + 'px !important;' +
          '    min-height: ' + CLOSE_MOBILE + 'px !important;' +
          '  }' +
          '}';
        // Also normalize the SVG's intrinsic width attribute so CSS can resize it
        // even on browsers that prefer the HTML attribute over CSS for SVG sizing.
        setTimeout(function () {
          var btn = d.shadowRoot.querySelector('[part~="close-button"]');
          var svg = btn && btn.querySelector('svg');
          if (svg) {
            svg.removeAttribute('width');
            svg.removeAttribute('height');
          }
        }, 100);
        /* ─── MEMO : hauteur de la croix alignée sur TOUS les autres tiroirs ──────
           Le user veut la croix du panier au même endroit que celle du sélecteur de
           boutique (« SELECT YOUR STORE ») : boîte de 38 px posée à 30 px du haut du
           panneau et 32 px du bord droit. Ici c'est le `padding-top` de l'en-tête qui
           la positionne (l'en-tête est en `align-items: center`, `min-height: 0`).
           ⚠️ Ces règles doivent être AJOUTÉES EN DERNIER : les règles du bandeau
           « Free gifts » ci-dessus reposent `padding-block` (donc aussi le haut) avec
           `!important` et une spécificité supérieure ; on les rattrape en répétant
           leurs sélecteurs, à égalité de spécificité mais plus loin dans la feuille.
           ⚠️ Et ça ne peut PAS se faire de l'extérieur : `cart-drawer::part(header)`,
           même en !important, perd contre ces règles internes (règle du cascade des
           arbres d'ombre : pour les déclarations !important, l'arbre interne gagne). */
        /* MAJ 16/09/2026 — Arthur a arbitre l'inverse : il trouvait le blanc du haut
           trop grand sur mobile. Valeur passee de 30 px a 12 px, sur Memo US ET Memo WW.
           Consequence assumee, ce n'est pas un oubli : la croix du panier ne tombe plus
           au meme endroit que celle du selecteur de boutique, restee a 30 px. */
        var closeTopCss =
          '[part="header"] {' +
          '  padding-top: 12px !important;' +
          '}' +
          ':host(.cart-drawer--has-gifts-banner):not(.drawer--center-body) [part="header"] {' +
          '  padding-top: 12px !important;' +
          '}' +
          ':host(.drawer--center-body) [part="header"] {' +
          '  padding-top: 12px !important;' +
          '}' +
          /* Le thème peint ce bouton en `opacity: .6` : la croix du panier ressortait
             GRISE là où toutes les autres croix du site sont en #3C3232 pleine encre —
             même tracé, même taille, même position, et pourtant « pas pareille ».
             On rétablit l'encre, et on remplace l'effet de survol perdu (l'opacité)
             par celui des autres croix : rotation 90° + léger zoom. */
          '[part~="close-button"] {' +
          '  opacity: 1 !important;' +
          '  color: #3C3232 !important;' +
          '}' +
          '[part~="close-button"] svg {' +
          '  transform-origin: center !important;' +
          '  transition: transform .25s ease !important;' +
          '}' +
          '[part~="close-button"]:hover svg {' +
          '  transform: rotate(90deg) scale(1.08) !important;' +
          '}';
        s.textContent = headerCompactCss + giftsBannerCss + closeCss + closeTopCss;
        d.shadowRoot.appendChild(s);
        return true;
      }
      if (!inject()) {
        var attempts = 0;
        var iv = setInterval(function () {
          attempts++;
          if (inject() || attempts > 40) clearInterval(iv);
        }, 50);
      }
    })();

/* ===== CAROUSEL ===== */
    (function () {
      if (window.__xmCarouselNavBound) return;
      window.__xmCarouselNavBound = true;

      function getCarousel(navEl) {
        var id = navEl.getAttribute('data-xm-nav-for');
        return id ? document.getElementById(id) : null;
      }
      function updateBtnState(nav, carousel) {
        var prev = nav.querySelector('[data-xm-prev]');
        var next = nav.querySelector('[data-xm-next]');
        var maxScroll = carousel.scrollWidth - carousel.clientWidth - 1;
        if (prev) prev.disabled = carousel.scrollLeft <= 0;
        if (next) next.disabled = carousel.scrollLeft >= maxScroll;
      }
      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-xm-prev], [data-xm-next]');
        if (!btn) return;
        var nav = btn.closest('[data-xm-nav-for]');
        if (!nav) return;
        var carousel = getCarousel(nav);
        if (!carousel) return;
        var direction = btn.matches('[data-xm-next]') ? 1 : -1;
        carousel.scrollBy({ left: carousel.clientWidth * direction, behavior: 'smooth' });
      });
      // Watch all nav widgets on each cart:refresh + initial.
      function bindAll() {
        document.querySelectorAll('cart-drawer [data-xm-nav-for]').forEach(function (nav) {
          if (nav.__xmBound) return;
          nav.__xmBound = true;
          var carousel = getCarousel(nav);
          if (!carousel) return;
          updateBtnState(nav, carousel);
          carousel.addEventListener('scroll', function () { updateBtnState(nav, carousel); }, { passive: true });
        });
      }
      bindAll();
      document.addEventListener('cart:refresh', function () { setTimeout(bindAll, 100); });
    })();

/* ===== DISCOUNT ===== */
    (function () {
      if (window.__xmDiscountAddBound) return;
      window.__xmDiscountAddBound = true;

      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-xm-discount-add]');
        if (!btn) return;
        e.preventDefault();
        var field = btn.closest('cart-discount-field');
        if (!field) return;
        if (field.getAttribute('aria-busy') === 'true') return;

        var input = field.querySelector('.xm-discount-input');
        if (!input) return;
        var newCode = (input.value || '').trim();
        if (!newCode) return;

        var hidden = field.querySelector('input[type="hidden"][name="discount"]');
        var existing = (hidden && hidden.value ? hidden.value : '')
          .split(',').map(function (c) { return c.trim(); }).filter(Boolean);

        var lower = existing.map(function (c) { return c.toLowerCase(); });
        if (lower.indexOf(newCode.toLowerCase()) === -1) existing.push(newCode);

        field.setAttribute('aria-busy', 'true');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: existing.join(',') })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (hidden) hidden.value = existing.join(',');
          input.value = '';
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {})
        .finally(function () { field.removeAttribute('aria-busy'); });
      });
    })();

/* ===== NOTE ===== */
    /* CART NOTE — save handler + input/character-counter handler.
       Lives at the top level of the cart drawer (not inside the cart-note-dialog
       custom element, which prevents the inline script from executing on some
       Shopify themes — the function name `handleInput{section.id}` would never
       be defined on window, and the inline `oninput=...` would silently fail). */
    (function () {
      if (window.__xmSaveCartNoteBound) return;
      window.__xmSaveCartNoteBound = true;

      var NOTE_CFG = window.XM_CART_NOTE_CFG || {};
      var LABEL_ADD = NOTE_CFG.labelAdd || '';
      var LABEL_EDIT = NOTE_CFG.labelEdit || '';
      var MAX_LINES = NOTE_CFG.maxLines || 0;
      var MAX_CHARS_PER_LINE = NOTE_CFG.maxCharsPerLine || 0;
      var MAX_CHARS_TOTAL = MAX_LINES * MAX_CHARS_PER_LINE;
      var CHAR_ONLY_MODE = !!NOTE_CFG.charOnlyMode;
      var ALLOW_EMOJI = !!NOTE_CFG.allowEmoji;
      var SECTION_ID = NOTE_CFG.sectionId || '';

      function syncOpenerLabels(noteVal) {
        var hasNote = (noteVal || '').trim().length > 0;
        document.querySelectorAll('[aria-controls^="cart-note-"]').forEach(function (opener) {
          var addLabel = opener.dataset.labelAdd || LABEL_ADD;
          var editLabel = opener.dataset.labelEdit || LABEL_EDIT;
          opener.textContent = hasNote ? editLabel : addLabel;
        });
      }

      /* Strip non-Latin chars + emojis (if disallowed), enforce line/char limits,
         and update the counter display. Mirrors the in-line handleInput function
         from the old version, but lives on the global scope so the textarea's
         oninput="" attribute can find it AND so event delegation works as a
         second safety net. */
      var LATIN_REGEX = /[^a-zA-Z0-9À-ž\s.,?!'"@#%^&*()\-_=+|\\:;<>/{}\[\]`~]/g;
      function handleInput(textarea) {
        if (!textarea) return;
        var charCountDisplay = document.getElementById('charCount' + SECTION_ID);
        var sideNote = document.getElementById('sideNote' + SECTION_ID);
        var value = textarea.value;

        value = value.replace(LATIN_REGEX, '');
        if (!ALLOW_EMOJI && window.__cartNoteEmojiRegex) {
          value = value.replace(window.__cartNoteEmojiRegex, '');
        }

        var lines = value.split('\n');
        if (CHAR_ONLY_MODE) {
          if (sideNote) sideNote.style.color = '';
          if (lines.length > MAX_LINES) {
            lines.splice(MAX_LINES);
            if (sideNote) sideNote.style.color = 'red';
          }
          value = lines.join('\n');
          if (value.length > MAX_CHARS_TOTAL) {
            value = value.substring(0, MAX_CHARS_TOTAL);
            if (sideNote) sideNote.style.color = 'red';
          }
        } else {
          if (sideNote) sideNote.style.color = '';
          for (var i = 0; i < lines.length; i++) {
            if (lines[i].length > MAX_CHARS_PER_LINE) {
              lines[i] = lines[i].substring(0, MAX_CHARS_PER_LINE);
              if (sideNote) sideNote.style.color = 'red';
            }
          }
          if (lines.length > MAX_LINES) lines.splice(MAX_LINES);
          value = lines.join('\n');
          if (value.length > MAX_CHARS_TOTAL) value = value.substring(0, MAX_CHARS_TOTAL);
        }

        textarea.value = value;
        if (charCountDisplay) charCountDisplay.textContent = value.length + '/' + MAX_CHARS_TOTAL;
        syncOpenerLabels(value);
      }

      /* Expose under the exact name the inline oninput="" attribute expects,
         so existing markup keeps working. */
      window['handleInput' + SECTION_ID] = handleInput;

      /* Belt-and-suspenders: also listen via delegation in case the inline
         attribute is stripped or the textarea is re-rendered by Section
         Rendering API. */
      document.addEventListener('input', function (e) {
        if (e.target && e.target.id === 'cart_note_textarea') handleInput(e.target);
      });

      /* Initial pass so the counter shows the correct value when the dialog
         opens with a pre-existing cart.note value. */
      function initCounter() {
        var ta = document.getElementById('cart_note_textarea');
        if (ta) handleInput(ta);
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCounter);
      } else {
        initCounter();
      }
      document.addEventListener('cart:refresh', function () { setTimeout(initCounter, 100); });

      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-xm-save-cart-note]');
        if (!btn) return;
        var ta = document.getElementById('cart_note_textarea');
        if (!ta) return;
        var noteVal = ta.value;
        /* Update every opener button immediately so the user sees the new label
           even before the /cart/update.js round-trip completes. */
        syncOpenerLabels(noteVal);
        /* Persist to cart. */
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: noteVal })
        }).then(function () {
          /* Re-sync in case any third-party listener overwrote the label after the
             cart update event. */
          syncOpenerLabels(noteVal);
        }).catch(function () {});
      });

      /* Also re-sync the opener label after any cart re-render (Section Rendering API).
         Walks the DOM once on cart:refresh to make sure the label matches the actual
         cart.note state. */
      function syncFromCart() {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart) return;
            syncOpenerLabels(cart.note || '');
          })
          .catch(function () {});
      }
      document.addEventListener('cart:refresh', syncFromCart);
      document.documentElement.addEventListener('cart:refresh', syncFromCart);
    })();

/* ===== VARIANT ===== */
    /* VARIANT CHANGE — when the customer picks a different size/option from the
       <select> rendered inside a line-item (see line-item.liquid `enable_variant_change`),
       swap the old line for the new variant via Shopify's cart API.

       RÉÉCRIT LE 15/09/2026. L'ancienne séquence retirait la ligne AVANT d'ajouter la nouvelle :
         - si le /cart/add.js échouait (variante passée en rupture entre l'affichage et le clic),
           la ligne était déjà supprimée et n'était jamais recréée -> le client perdait son article ;
         - aucune réponse n'était vérifiée (pas de test r.ok) ;
         - les propriétés de ligne étaient perdues : un parfum GRAVÉ changeant de format
           repartait sans sa gravure, en silence ;
         - le /cart.js initial ne servait à rien (la quantité ajoutée valait toujours oldQty) ;
         - le retrait se faisait par INDEX de ligne, or le moteur cadeaux décale les index.

       Nouvelle séquence, sûre par construction :
         1. GET  /cart.js            — retrouve la ligne par sa CLÉ (stable) : quantité + propriétés
         2. POST /cart/add.js        — ajoute la nouvelle variante AVEC les mêmes propriétés
                                        (si ça échoue : panier intact, on remet le <select> en place)
         3. POST /cart/change.js     — retire l'ancienne ligne par sa clé, une fois l'ajout confirmé
         4. cart:refresh             — le tiroir et la page panier se re-rendent

       Delegated on document so it survives Section Rendering API re-renders. */
    (function () {
      if (window.__xmVariantChangeBound) return;
      window.__xmVariantChangeBound = true;

      function refreshCart() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      function setBusy(sel, busy) {
        if (busy) {
          sel.setAttribute('aria-busy', 'true');
          sel.disabled = true;
        } else {
          sel.removeAttribute('aria-busy');
          sel.disabled = false;
        }
      }

      /* Propriétés à REPORTER sur la nouvelle ligne : tout ce que le client a saisi (gravure,
         message…). On écarte les propriétés techniques du moteur cadeaux : une ligne cadeau n'a
         pas de sélecteur de variante, mais la garde évite de fabriquer un faux cadeau si la
         configuration change un jour. */
      function carryProperties(props) {
        var out = {};
        if (!props) return out;
        Object.keys(props).forEach(function (k) {
          if (k === '_memo_gift') return;
          var v = props[k];
          if (v === null || v === undefined || v === '') return;
          out[k] = v;
        });
        return out;
      }

      function jsonOk(r) {
        if (!r || !r.ok) throw new Error('cart API ' + (r ? r.status : 'network'));
        return r.json();
      }

      document.addEventListener('change', function (e) {
        var sel = e.target;
        if (!sel || !sel.matches || !sel.matches('[data-xm-variant-change]')) return;

        var lineKey = String(sel.dataset.lineKey || '');
        var lineIndex = parseInt(sel.dataset.lineIndex, 10);
        var currentVariantId = String(sel.dataset.currentVariant || '');
        var newVariantId = String(sel.value);

        if (!newVariantId || newVariantId === currentVariantId) return;
        if (!lineKey && !lineIndex) return;

        setBusy(sel, true);

        /* Étape 1 : lire l'état RÉEL de la ligne (quantité + propriétés) au moment du clic.
           On retrouve la ligne par sa clé ; repli sur l'index si la clé manque (vieux rendu). */
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(jsonOk)
          .then(function (cart) {
            var items = (cart && cart.items) || [];
            var oldLine = null;
            if (lineKey) {
              for (var i = 0; i < items.length; i++) { if (items[i].key === lineKey) { oldLine = items[i]; break; } }
            }
            if (!oldLine && lineIndex > 0 && items[lineIndex - 1]) oldLine = items[lineIndex - 1];
            /* La ligne a disparu entre l'affichage et le clic (retrait dans un autre onglet,
               moteur cadeaux…) : on ne fabrique rien, on laisse le panier se re-rendre. */
            if (!oldLine || String(oldLine.variant_id) !== currentVariantId) {
              refreshCart();
              return null;
            }
            var qty = oldLine.quantity || parseInt(sel.dataset.quantity, 10) || 1;
            var props = carryProperties(oldLine.properties);
            var addBody = { id: parseInt(newVariantId, 10), quantity: qty };
            if (Object.keys(props).length) addBody.properties = props;

            /* Étape 2 : AJOUTER d'abord. Si la nouvelle variante est indisponible, l'appel échoue
               et le panier n'a pas bougé d'un pouce. */
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [addBody] })
            })
              .then(jsonOk)
              /* Étape 3 : retirer l'ancienne variante.
                 ⚠️ On NE peut PAS réutiliser la clé lue à l'étape 1 : entre l'ajout et le retrait,
                 une remise automatique (Shopify Function, ex. « Free candle ») peut RE-DÉCOUPER la
                 ligne en plusieurs lignes aux clés neuves. /cart/change.js sur une clé périmée
                 répond 200 sans rien retirer, et le client se retrouvait avec l'ancienne ET la
                 nouvelle variante au panier (constaté en test le 15/09/2026).
                 On relit donc le panier et on retire TOUTES les lignes de l'ancienne variante
                 portant les mêmes propriétés, en UNE requête /cart/update.js. */
              .then(function () {
                return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(jsonOk);
              })
              .then(function (fresh) {
                var wanted = JSON.stringify(props);
                var updates = {};
                ((fresh && fresh.items) || []).forEach(function (l) {
                  if (String(l.variant_id) !== currentVariantId) return;
                  if (JSON.stringify(carryProperties(l.properties)) !== wanted) return;
                  updates[l.key] = 0;
                });
                if (!Object.keys(updates).length) return null;
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ updates: updates })
                }).then(jsonOk);
              })
              .then(function () { refreshCart(); });
          })
          .catch(function () {
            /* Échec : on remet le <select> sur la variante réellement au panier. Rien n'a été
               perdu puisque le retrait ne se fait qu'après un ajout confirmé. */
            sel.value = currentVariantId;
            refreshCart();
          })
          .finally(function () { setBusy(sel, false); });
      });
    })();

/* ===== EXPRESS ===== */
          (function () {
            if (window.__xmExpressLimitBound) return;
            window.__xmExpressLimitBound = true;

            // Shopify renders accelerated checkout as custom elements (modern markup):
            //   <shopify-accelerated-checkout-cart>
            //     <shop-pay-wallet-button>...</shop-pay-wallet-button>
            //     <shopify-paypal-button>...</shopify-paypal-button>
            //     <shopify-google-pay-button>...</shopify-google-pay-button>
            //   </shopify-accelerated-checkout-cart>
            // We hide the wallet custom elements past the configured limit.
            var WALLET_SELECTOR = [
              'shop-pay-wallet-button',
              'shopify-paypal-button',
              'shopify-google-pay-button',
              'shopify-apple-pay-button',
              'shopify-amazon-pay-button',
              'shopify-meta-pay-button'
            ].join(',');

            function apply() {
              document.querySelectorAll('.cart-drawer__express-checkout[data-mobile-limit]').forEach(function (container) {
                var limit = parseInt(container.dataset.mobileLimit || '2', 10);
                var isMobile = window.matchMedia('(max-width: 999px)').matches;

                var buttons = Array.prototype.slice.call(container.querySelectorAll(WALLET_SELECTOR));

                // Reset previously hidden wallets + any previous clip
                container.querySelectorAll('[data-xm-hidden-by-limit]').forEach(function (el) {
                  el.style.display = '';
                  el.removeAttribute('data-xm-hidden-by-limit');
                });
                container.style.height = '';
                container.style.overflow = '';

                if (isMobile && buttons.length > limit) {
                  buttons.slice(limit).forEach(function (el) {
                    el.style.display = 'none';
                    el.setAttribute('data-xm-hidden-by-limit', '1');
                  });
                }

                // Clip away any phantom empty cells that Shopify renders in its closed shadow
                // root for wallets that aren't available on this device (e.g. Apple Pay on
                // desktop). We measure where the last LIGHT-DOM wallet ends and cut the
                // container's height there.
                requestAnimationFrame(function () {
                  var visibleButtons = buttons.filter(function (el) {
                    return el.style.display !== 'none';
                  });
                  if (!visibleButtons.length) return;
                  var containerTop = container.getBoundingClientRect().top;
                  var lastBottom = containerTop;
                  visibleButtons.forEach(function (el) {
                    var r = el.getBoundingClientRect();
                    if (r.height > 0 && r.bottom > lastBottom) lastBottom = r.bottom;
                  });
                  var height = lastBottom - containerTop;
                  if (height > 0) {
                    container.style.height = height + 'px';
                    container.style.overflow = 'hidden';
                  }
                });
              });
            }

            function init() {
              apply();
              window.addEventListener('resize', apply);
              document.querySelectorAll('.cart-drawer__express-checkout').forEach(function (c) {
                new MutationObserver(apply).observe(c, { childList: true, subtree: true });
              });
            }
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', init);
            } else {
              init();
            }
          })();
